import type { GridRenderCellParams, GridValidRowModel } from '@mui/x-data-grid';
import React from 'react';
import { useDispatch } from 'react-redux';

import { updateTableContext } from 'FRONTEND/reducers/tableSlice';

export const LinkCell = (params: GridRenderCellParams<GridValidRowModel>) => {
  const dispatch = useDispatch();
  const href = params.row?.links?.find((link) => link.rel === 'self')?.href;
  const location = window.location.pathname;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    dispatch(updateTableContext({ tableName: location, contextObject: { previouslySelectedConsultationId: params.row.consultation_id } }));
  };
  return (
    <a
      href={href}
      data-pjax
      onClick={handleClick}
      style={{
        textDecoration: 'none',
        color: 'inherit',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      {params.formattedValue ?? params.value}
    </a>
  );
};
